import React, { useState } from 'react';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import { AppContext } from './_context';
import { IUser } from './_schema';
import './app.css';

import { Authorized } from './authorized';
import { Unauthorized } from './unauthorized';

const theme = createMuiTheme({
  palette: {
    primary: {
      // main: '#4DA6F5' // Brand 3. TODO: Setup Style Guide
      main: '#3f51b5',
    },
  },
});

function App() {
  const [user, setUserState] = useState<IUser>({
    isLoggedIn: false,
    name: '',
  });

  const loginUser = (login: any) => {
    setUserState({
      isLoggedIn: true,
      name: login.userNameOrEmail,
    });
  };

  const logoutUser = () => {
    setUserState({
      isLoggedIn: false,
      name: '',
    });
  };

  return (
    <MuiThemeProvider theme={theme}>
      <AppContext.Provider value={{ user, loginUser, logoutUser }}>
        {user.isLoggedIn ? <Authorized /> : <Unauthorized />}
      </AppContext.Provider>
    </MuiThemeProvider>
  );
}

export default App;
